import * as $ from 'jquery';
import 'bootstrap';
import 'slick';

export class relatedPartners{
	relatedpartnerSlider(): any{
		$('.enrich-partner--detailed').slick({
			infinite: false,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 2,
			dots: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 2,
						dots: true
					}
				},
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						dots: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: false
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}
}

let scope:Element = document.querySelector('.related-partners');
if (scope){
	try {
	let relatedpartners = new relatedPartners();
			relatedpartners.relatedpartnerSlider();
	} catch(e) {console.error(e);}
}
